import { makeStyles } from 'transfix-ui/core/styles'

export const useRecipientsFormSectionStyles = makeStyles(theme => ({
  recipients: {
    margin: `${theme.spacing(3.5)} 0 0`,
  },
}))
